import axios from 'axios'
import { stateUrl, getHeader } from '@/config'

const state = {
  stateList: []
}

const mutations = {
  SET_STATE_LIST (state, obj) {
    state.stateList = obj
  }
}

const actions = {
  getStateList: ({ commit }) => {
    axios.get(stateUrl, { headers: getHeader() })
      .then(response => {
        console.log(response.data.data)
        commit('SET_STATE_LIST', response.data.data)
      })
  }
}

export default {
  state, mutations, actions
}
